export default __webpack_public_path__ + "static/media/freeCodeCamp.3785c5a6.svg";